// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DialogButtonsWrapper_wrapper__op6P1","fullWidth":"DialogButtonsWrapper_fullWidth__OqVZ1"};